<template>
  <div>
    <div v-if="isPaymentRewardType || item.isSuccessful">
      <p>
        {{ $t('redemption-history-need-help') }}
      </p>
    </div>
    <tc-v-btn
      id="help-btn"
      color="primary"
      outlined
      class="rounded"
      @click="startupChatbot"
    >
      {{ $t('redemption-history-start-chatbot-button-text') }}
    </tc-v-btn>
    <p v-if="!isPaymentRewardType && item.isUnsuccessful">
      <span class="d-block text-caption ui-icon-link">
        {{ $t('redemption-history-learn-more') }}
      </span>
    </p>
  </div>
</template>

<script>
import { RedeemedItem } from '@/store/classes/redeemed-item'
import { REDEMPTION_HELP_CAMPAIGN_KEY } from '@/components/shared/ada/ada-container'

export default {
  name: 'RedemptionHistoryNeedHelp',
  props: {
    item: {
      type: RedeemedItem,
      required: true
    },
    isPaymentRewardType: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    startupChatbot () {
      this.$adaChatbot.triggerCampaign(
        REDEMPTION_HELP_CAMPAIGN_KEY,
        { redemption_reference_id: this.item.referenceLineItemId }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/variables';

#help-btn {
  text-transform: initial;
  background: $tangoWhite;
}
p {
  line-height: 1.2rem;
  margin-bottom: 0.5rem;
}
</style>
